import { Hero } from '@/components/sections/home/Hero'
import { ServiceOverview } from '@/components/sections/home/ServiceOverview'
import { LatestInsights } from '@/components/sections/home/LatestInsights'
// import { Metrics } from '@/components/sections/home/Metrics'

export function HomePage() {
  return (
    <>
      <Hero />
      <ServiceOverview />
      <LatestInsights />
      {/* <Metrics /> */}
    </>
  )
} 